<!--
  Similar to el-autocomplete-suggestions but with resolvable imports
  https://github.com/ElemeFE/element/blob/dev/packages/autocomplete/src/autocomplete-suggestions.vue

  Also has a richer position for the suggestion,
  thus can be displayed directly under the selected word
-->

<template>
  <transition name="el-zoom-in-top" @after-leave="doDestroy">
    <div
      v-show="showPopper"
      class="el-autocomplete-suggestion el-popper"
      :class="{ 'is-loading': !parent.hideLoading && parent.loading }"
      :style="{ width: dropdownWidth }"
      role="region">
      <el-scrollbar
        tag="ul"
        wrap-class="el-autocomplete-suggestion__wrap"
        view-class="el-autocomplete-suggestion__list">
        <li v-if="!parent.hideLoading && parent.loading"><i class="el-icon-loading"></i></li>
        <slot v-else>
        </slot>
      </el-scrollbar>
    </div>
  </transition>
</template>
<script>
import Popper from 'element-ui/lib/utils/vue-popper'
import Emitter from 'element-ui/lib/mixins/emitter'
import ElScrollbar from 'element-ui/lib/scrollbar'

export default {
  name: 'ElMobileSuggestions',

  components: { ElScrollbar },
  mixins: [Popper, Emitter],

  componentName: 'ElAutocompleteSuggestions',

  data () {
    return {
      parent: this.$parent,
      dropdownWidth: null,
      cursorX: null,
      cursorY: null,
    }
  },

  props: {
    options: {
      default () {
        return {
          gpuAcceleration: false,
        }
      },
    },
    width: Number,
    id: String,
  },

  methods: {
    select (item) {
      this.dispatch('ElAutocomplete', 'item-click', item)
    },

    // overhides updatePopper from Popper
    // changes the position of the suggestion
    updatePopper () {
      Popper.methods.updatePopper.call(this)
      if (!this.width) return
      let popper = this.popperJS && this.popperJS._popper
      if (popper) {
        let width = this.width
        let minx = parseInt(popper.style.left)
        let maxx = minx + parseInt(this.dropdownWidth) - width
        let x = this.cursorX ? this.cursorX - width / 2 : minx
        x = Math.max(Math.min(x, maxx), minx)
        let y = this.cursorY ? this.cursorY : parseInt(popper.style.top)
        popper.style.left = x + 'px'
        popper.style.top = y + 'px'
        popper.style.width = width + 'px'
      }
    },
  },

  updated () {
    this.$nextTick(_ => {
      this.popperJS && this.updatePopper()
    })
  },

  mounted () {
    this.$parent.popperElm = this.popperElm = this.$el
    this.referenceElm = this.$parent.$refs.input.$refs ? this.$parent.$refs.input.$refs.input : this.$parent.$refs.input
    this.referenceList = this.$el.querySelector('.el-autocomplete-suggestion__list')
    this.referenceList.setAttribute('role', 'listbox')
    this.referenceList.setAttribute('id', this.id)
  },

  created () {
    this.$on('visible', (val, inputWidth, cursorX, cursorY) => {
      this.dropdownWidth = inputWidth + 'px'
      this.showPopper = val
      // get preferred suggestion position
      if (cursorX) this.cursorX = cursorX
      if (cursorY) this.cursorY = cursorY
    })
  },
}
</script>
